import { User } from "@wexinc/wex-common-web";
import { Role } from "services/security";

export interface OrganizationLineage extends OrganizationInfo {
  children: OrganizationInfoExpanded[];
}

export interface OrganizationInfoExpanded extends OrganizationInfo {
  subOrgCount: number;
  memberCount: number;
}

export interface OrganizationInfo extends BaseOrganizationInfo {
  id: string;
  parent?: ParentOrganizationInfo;
}

export interface BaseOrganizationInfo {
  name: string;
  description?: string;
  accessType: "EXTERNAL" | "INTERNAL";
  contactEmail: string | null;
}

export interface ParentOrganizationInfo {
  id: string;
  name: string;
  parent?: ParentOrganizationInfo;
}

export interface OrganizationDetails extends OrganizationInfo {
  id: string;
  members: OrganizationMember[];
  invitees: OrganizationInvitation[];
}

export interface OrganizationLoginConfig {
  usernameAndPasswordEnabled: boolean;
  identityProviderIds: string[];
}

export interface Organization extends AddOrganization {
  id: string;
}

export interface AddOrganization extends BaseOrganizationInfo {
  parentOrganizationId?: string;
  loginConfig: OrganizationLoginConfig;
}

export interface OrganizationMember {
  user: User;
  roles: Role[];
}

export type OrganizationInviteStatus =
  | "ADDED"
  | "INVITATION_SENT"
  | "ALREADY_INVITED"
  | "ERROR"
  | "ALREADY_ADDED"
  | "DEACTIVATED_USER";

export interface AddMemberResponse<T> {
  email: string;
  error: {
    code: 0;
    errors: [
      {
        details: string;
        field: string;
        message: string;
      },
    ];
  } | null;
  invitation?: T;
  member?: {
    roles: Role[];
    user: User;
  };
  status: OrganizationInviteStatus;
}

export interface OrganizationInvitation {
  id: number;
  email: string;
  createdAt: Date;
  expiresAt: Date;
}

/* Type Guards */
export function isOrganizationDetails(
  org: OrganizationDetails | OrganizationInfo | AddOrganization,
): org is OrganizationDetails {
  return (org as OrganizationDetails).members !== undefined;
}
